<template>
  <v-layout wrap>
    <v-flex xs12 pa-2>
      <v-toolbar class="legend" outline color="grey lighten-3"  dense flat>
        <v-row align="center" justify="center">
          <v-btn class="ma-1 legend-text" depressed tile :color="getStatusLevel('정상가동')">정상가동</v-btn>
          <v-btn class="ma-1 legend-text" depressed tile :color="getStatusLevel('품질이상')">품질이상</v-btn>
          <v-btn class="ma-1 legend-text" depressed tile :color="getStatusLevel('설비이상')">설비이상</v-btn>
          <v-btn class="ma-1 legend-text" depressed tile :color="getStatusLevel('자재결품')">자재결품</v-btn>
          <v-btn class="ma-1 legend-text" depressed tile :color="getStatusLevel('계획정지')">계획정지</v-btn>
          <v-btn class="ma-1 legend-text" depressed tile :color="getStatusLevel('안전이상')">안전이상</v-btn>
          
          
        </v-row>
      </v-toolbar> 
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  components: {
  },
  data() {
    return {
    }
  },
  computed:{ 
  },
  created () {    
  },
  beforeDestroy () {
  },
  methods: {
    getStatusLevel (value) {
      switch (value) {
        case '정상가동':
          return 'green';
          break;
        case '품질이상':
          return '#FEB6B7';
          break;
        case '설비이상':
          return 'red';
          break;
        case '자재결품':
          return 'yellow';
          break;
        case '계획정지':
          return '#FEC000';
          break;
        case '안전이상':
          return '#D9D9D9';
          break;
        default:
          break;
      }
    }
  }
}
</script>
<style>
.legend button {
  cursor: default;
}
</style>